module.exports = __webpack_public_path__ + "static/media/financial_statements.effedafd.svg";